import { NavLink } from "react-router-dom";
import "./styles/footer.css"; // Assuming you have a CSS file for styles

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-left">
          <NavLink to="/" className="footer-logo">
            YourEnergyGuru
          </NavLink>
          <p className="footer-copy">
            © {new Date().getFullYear()} Your Energy Guru. All rights reserved.
          </p>
        </div>

        <nav className="footer-nav">
          <NavLink to="/purchase-leads" className="footer-link">
            Solar Leads
          </NavLink>
          <NavLink to="/contact" className="footer-link">
            Contact Us
          </NavLink>
          <NavLink to="/faq" className="footer-link">
            FAQ
          </NavLink>
        </nav>
      </div>
    </footer>
  );
}
